import React from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import filmHero from "./img/Film1.webp";
import { ensureNamespace } from "../../i18n/ensurePageI18n";

const loadI18n = (i18n) => {
  ensureNamespace(i18n, 'films', {
    en: {
      sectionTitle: "Films",
      sectionSubtitle: "Surface Inspection Systems for Film Applications",
      title: "FILMS",
      heroDesc: "Wintriss surface inspection systems for film applications are used worldwide by leading manufactures and OEM’s alike. Our Web Ranger® modular platform is easily configured to material width, production speed and defect parameters of the film being inspected.",
      typesTitle: "Film Types",
      typesSubtitle: "Packaging & Specialty Film Applications",
      typesContent: "Blown films, cast films, extruded films, BOPP, BOPET, BOPA, CPP, PVC, CPE, PI, PVB, APET, ABS, PC/PMMA film, metalized film, and more.",
      opticalTitle: "Optical Film Applications",
      opticalContent: "Optical grade BOPET, polarizer film, prism film, TAC, OPF, window film, PVA, 3D film, Light guide plate, optical protective film, BEF, diffusion film, anti-reflective film, anti-glare film, LCP film, CPI film, and more.",
      defectsTitle: "Typical Defects",
      defectsContent: "Bright spot, scratch, micro-scratch, gels, bumps, streaks, voids, stains, pinholes, crease, folds, contaminants, etc."
    },
    zh: {
      sectionTitle: "塑膠薄膜",
      sectionSubtitle: "薄膜應用的表面檢測系統",
      title: "塑膠薄膜",
      heroDesc: "微覺視的薄膜檢測系統已被全球主要製造商與 OEM 採用。模組化 Web Ranger® 平台可依檢測薄膜的寬度、速度與缺陷參數快速配置。",
      typesTitle: "薄膜型態",
      typesSubtitle: "包裝與特殊薄膜應用",
      typesContent: "吹膜、鑄膜、擠出膜、BOPP、BOPET、BOPA、CPP、PVC、CPE、PI、PVB、APET、ABS、PC/PMMA 薄膜、鍍金屬薄膜等。",
      opticalTitle: "光學薄膜應用",
      opticalContent: "光學級 BOPET、偏光片、稜鏡膜、TAC、OPF、窗膜、PVA、3D 薄膜、導光板、光學保護膜、BEF、擴散膜、抗反射膜、抗眩膜、LCP、CPI 等。",
      defectsTitle: "常見缺陷",
      defectsContent: "亮點、刮傷、微刮傷、凝膠、凸起、條紋、空隙、污漬、針孔、摺痕、褶皺及污染物等。"
    }
  });
};

function Films() {
  const { t, i18n } = useTranslation();
  loadI18n(i18n);

  return (
    <div>
      <section className="section-films relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t("films:sectionTitle")}</h1>
          <p className="text-xl text-white">{t("films:sectionSubtitle")}</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">{t("films:title")}</h2>
          <p className="leading-relaxed text-sm md:text-base">{t("films:heroDesc")}</p>
        </div>
        <div className="flex justify-center">
          <img src={filmHero} alt={t("films:title")} className="rounded-lg shadow-lg w-full max-w-md object-cover" loading="lazy" />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-20 grid md:grid-cols-3 gap-10">
        <div className="bg-white border rounded-lg p-6 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("films:typesTitle")}</h3>
          <h4 className="text-sm font-medium text-gray-600 mb-2">{t("films:typesSubtitle")}</h4>
          <p className="text-sm text-gray-700 leading-relaxed">{t("films:typesContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-6 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("films:opticalTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("films:opticalContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-6 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("films:defectsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("films:defectsContent")}</p>
        </div>
      </section>
    </div>
  );
}

export default Films;
